import React, { useEffect, useState } from "react";
import { Card, Input, Button, Form, message } from "antd";
import { apiRequest } from "../../../service/apiRequest";


const CompanySettings: React.FC = () => {
    const [gstNumber, setGstNumber] = useState("");
    const [loading, setLoading] = useState(false);
    const fetchCompanyDetails = async () => {
        try {
            const res = await apiRequest({
                method: "get",
                url: "/get-company-setting"
            });

            setGstNumber(res?.od_gst_no || "");
        } catch (err) {
            message.error("Failed to fetch company details");
        }
    };

    useEffect(() => {
        fetchCompanyDetails();
    }, []);

    const handleUpdate = async () => {
        if (!gstNumber) {
            return message.error("GST number is required");
        }

        try {
            setLoading(true);

            await apiRequest({
                method: "put",
                url: "/update-company-setting",
                data: {
                    od_gst_no: gstNumber,
                },
            });

            message.success("GST updated successfully");
        } catch (err) {
            message.error("Failed to update GST");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ maxWidth: 500 }}>
            <h2>Company Settings</h2>
            <Form layout="vertical">
                <Form.Item label="GST Number">
                    <Input
                        placeholder="Enter GST Number"
                        value={gstNumber}
                        onChange={(e) => setGstNumber(e.target.value.toUpperCase())}
                    />
                </Form.Item>

                <Button type="primary" loading={loading} onClick={handleUpdate}>
                    Update GST
                </Button>
            </Form>
        </div>
    );
};

export default CompanySettings;